// THEMA top-level subject categories for book genre classification
// Based on the international THEMA standard (https://www.editeur.org/151/thema/)
// Using top-level codes only for genre selection

export const THEMA_CODES = [
  { code: 'A', label: 'The Arts' },
  { code: 'AB', label: 'Art & Art History' },
  { code: 'AF', label: 'Film, TV & Radio' },
  { code: 'AG', label: 'Music' },
  { code: 'AK', label: 'Design' },
  { code: 'C', label: 'Language & Linguistics' },
  { code: 'D', label: 'Biography & True Stories' },
  { code: 'DN', label: 'Biography & Memoir' },
  { code: 'F', label: 'Fiction' },
  { code: 'FA', label: 'Modern & Contemporary Fiction' },
  { code: 'FB', label: 'Fiction: General & Literary' },
  { code: 'FC', label: 'Biographical Fiction' },
  { code: 'FD', label: 'Drama & Playscripts' },
  { code: 'FH', label: 'Thriller / Suspense' },
  { code: 'FJ', label: 'Adventure Fiction' },
  { code: 'FK', label: 'Horror & Supernatural Fiction' },
  { code: 'FL', label: 'Science Fiction' },
  { code: 'FM', label: 'Fantasy' },
  { code: 'FN', label: 'Myths & Legends' },
  { code: 'FP', label: 'Erotic Fiction' },
  { code: 'FQ', label: 'Historical Fiction' },
  { code: 'FR', label: 'Romance' },
  { code: 'FRD', label: 'Romantic Suspense' },
  { code: 'FRF', label: 'Romantic Fantasy (Romantasy)' },
  { code: 'FT', label: 'Short Stories & Anthologies' },
  { code: 'FV', label: 'Family Life / Domestic Fiction' },
  { code: 'FW', label: 'Religious & Spiritual Fiction' },
  { code: 'FX', label: 'Graphic Novels & Manga' },
  { code: 'FY', label: 'Fiction: Special Features' },
  { code: 'G', label: 'Reference & Encyclopaedias' },
  { code: 'J', label: 'Society & Social Sciences' },
  { code: 'JB', label: 'Sociology' },
  { code: 'JM', label: 'Psychology' },
  { code: 'K', label: 'Economics & Finance' },
  { code: 'L', label: 'Law' },
  { code: 'M', label: 'Medicine & Health' },
  { code: 'N', label: 'History' },
  { code: 'P', label: 'Mathematics & Science' },
  { code: 'Q', label: 'Philosophy & Religion' },
  { code: 'R', label: 'Earth Sciences & Geography' },
  { code: 'S', label: 'Sports & Active Outdoor' },
  { code: 'T', label: 'Technology & Engineering' },
  { code: 'U', label: 'Computing & IT' },
  { code: 'V', label: 'Health, Relationships & Self-help' },
  { code: 'VS', label: 'Self-help & Personal Development' },
  { code: 'VX', label: 'Mind, Body, Spirit' },
  { code: 'W', label: 'Lifestyle, Hobbies & Leisure' },
  { code: 'WB', label: 'Cooking & Food' },
  { code: 'WM', label: 'Gardening' },
  { code: 'WT', label: 'Travel' },
  { code: 'X', label: 'Graphic Novels, Comics & Manga' },
  { code: 'Y', label: 'Children\'s & Young Adult' },
  { code: 'YF', label: 'Children\'s Fiction' },
  { code: 'YFH', label: 'YA Fantasy' },
  { code: 'YFM', label: 'YA Romance' },
];

// Curated accent colour palette for author branding
// All work well with the Narratoria slate base theme
export const AUTHOR_ACCENT_COLORS = [
  { id: 'teal', label: 'Teal', hsl: '174 58% 39%', tailwind: 'teal' },
  { id: 'indigo', label: 'Indigo', hsl: '239 84% 67%', tailwind: 'indigo' },
  { id: 'rose', label: 'Rose', hsl: '347 77% 50%', tailwind: 'rose' },
  { id: 'violet', label: 'Violet', hsl: '263 70% 50%', tailwind: 'violet' },
  { id: 'emerald', label: 'Emerald', hsl: '160 84% 39%', tailwind: 'emerald' },
  { id: 'sky', label: 'Sky', hsl: '199 89% 48%', tailwind: 'sky' },
  { id: 'orange', label: 'Sunset', hsl: '25 95% 53%', tailwind: 'orange' },
  { id: 'pink', label: 'Pink', hsl: '330 81% 60%', tailwind: 'pink' },
];

// Get accent colour classes for an author
export function getAccentClasses(colorId) {
  const colorMap = {
    teal: { bg: 'bg-teal-600', hover: 'hover:bg-teal-700', text: 'text-teal-600', light: 'bg-teal-50', border: 'border-teal-200', ring: 'ring-teal-500' },
    indigo: { bg: 'bg-indigo-600', hover: 'hover:bg-indigo-700', text: 'text-indigo-600', light: 'bg-indigo-50', border: 'border-indigo-200', ring: 'ring-indigo-500' },
    rose: { bg: 'bg-rose-600', hover: 'hover:bg-rose-700', text: 'text-rose-600', light: 'bg-rose-50', border: 'border-rose-200', ring: 'ring-rose-500' },
    violet: { bg: 'bg-violet-600', hover: 'hover:bg-violet-700', text: 'text-violet-600', light: 'bg-violet-50', border: 'border-violet-200', ring: 'ring-violet-500' },
    emerald: { bg: 'bg-emerald-600', hover: 'hover:bg-emerald-700', text: 'text-emerald-600', light: 'bg-emerald-50', border: 'border-emerald-200', ring: 'ring-emerald-500' },
    sky: { bg: 'bg-sky-600', hover: 'hover:bg-sky-700', text: 'text-sky-600', light: 'bg-sky-50', border: 'border-sky-200', ring: 'ring-sky-500' },
    orange: { bg: 'bg-orange-600', hover: 'hover:bg-orange-700', text: 'text-orange-600', light: 'bg-orange-50', border: 'border-orange-200', ring: 'ring-orange-500' },
    pink: { bg: 'bg-pink-600', hover: 'hover:bg-pink-700', text: 'text-pink-600', light: 'bg-pink-50', border: 'border-pink-200', ring: 'ring-pink-500' },
  };
  return colorMap[colorId] || colorMap.teal;
}
